import { ref } from 'vue'
import FaqItem from '@/models/FaqItem'
import { useLoading } from '@/composables/useLoading'

export default function FaqController () {
  const { loading, loadingOn, loadingOff } = useLoading()

  const faqItems = ref([])

  const mess = ref(null)
  const messVisible = ref(false)
  const setMess = (msg) => {
    mess.value = msg
    messVisible.value = true
    setTimeout(() => (messVisible.value = false), 2000)
  }

  const error = ref(null)
  const setError = (err) => {
    error.value = err
    setTimeout(() => (error.value = ''), 3000)
  }

  const getFaq = async () => {
    loadingOn()
    const response = await fetch('https://valeriya-artist-admin.ru/api/faq', {
      method: 'GET',
      headers: {
        Authorization: localStorage.getItem('admin_token')
      }
    })
    const res = await response.json()
    if (response.ok) {
      faqItems.value = res.map((o) => new FaqItem(o))
    } else setError(res.err)
    loadingOff()
  }

  const faqApiWrapper = async (url, payload) => {
    loadingOn()
    const response = await fetch(`https://valeriya-artist-admin.ru/api/faq/${url}`, {
      method: 'POST',
      headers: {
        Authorization: localStorage.getItem('admin_token')
      },
      body: JSON.stringify(payload)
    })
    const res = await response.json()
    if (response.ok) {
      setMess(res.mess)
      getFaq()
    } else setError(res.err)
    loadingOff()
  }

  return {
    getFaq,
    faqItems,
    faqApiWrapper,
    mess,
    messVisible,
    error,
    loading
  }
}
